/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Carry_LeadInputs */

const en_us2_workout_after_carry_lead = /** @type {(inputs: Workout_After_Carry_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today you trained differently from your plan. Choose what goes into it; everything else stays as it is.`)
};

const pt_br2_workout_after_carry_lead = /** @type {(inputs: Workout_After_Carry_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoje você treinou diferente do plano. Escolha o que entra nele; o resto continua como está.`)
};

const es_419_workout_after_carry_lead = /** @type {(inputs: Workout_After_Carry_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoy entrenaste diferente de tu plan. Elige lo que pasa al plan; lo demás queda como está.`)
};

const pt_pt2_workout_after_carry_lead = /** @type {(inputs: Workout_After_Carry_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoje treinaste de forma diferente do plano. Escolhe o que entra nele; o resto fica como está.`)
};

const fr_fr2_workout_after_carry_lead = /** @type {(inputs: Workout_After_Carry_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aujourd'hui, tu t'es entraîné autrement que prévu. Choisis ce qui entre dans ton programme ; le reste ne change pas.`)
};

const de_de2_workout_after_carry_lead = /** @type {(inputs: Workout_After_Carry_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast heute anders trainiert als im Plan. Wähl, was übernommen wird; alles andere bleibt, wie es ist.`)
};

const it_it2_workout_after_carry_lead = /** @type {(inputs: Workout_After_Carry_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oggi ti sei allenato in modo diverso dalla scheda. Scegli cosa entra; il resto rimane com'è.`)
};

/**
* | output |
* | --- |
* | "Today you trained differently from your plan. Choose what goes into it; everything else stays as it is." |
*
* @param {Workout_After_Carry_LeadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_carry_lead = /** @type {((inputs?: Workout_After_Carry_LeadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Carry_LeadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_carry_lead(inputs)
	if (locale === "es-419") return es_419_workout_after_carry_lead(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_carry_lead(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_carry_lead(inputs)
	if (locale === "de-DE") return de_de2_workout_after_carry_lead(inputs)
	if (locale === "it-IT") return it_it2_workout_after_carry_lead(inputs)
	return en_us2_workout_after_carry_lead(inputs)
});
export { workout_after_carry_lead as "workout-after.carry_lead" }